/* eslint-disable import/prefer-default-export */
import { searchFetch, setCategory, generateCategories, clearResults } from './'
import { parseQuery } from '../../../utils/navigation'

const generateAvailableCategories = (dispatch, results) => {
  if (results) {
    const categories = ['all']

    if (results?.tutorials?.count > 0) categories.push('courses')
    if (results?.posts?.count > 0) categories.push('posts')
    if (results?.artists?.count > 0) categories.push('artists')

    dispatch(generateCategories(categories))
  }
}

// Helper to get query params from location (RR6 compatible)
const getQueryParams = (props) => {
  const search = props?.location?.search || ''
  return parseQuery(search)
}

export const searchDispatchers = (dispatch, props) => ({
  getResults(params) {
    const fetchParams = params || { ...getQueryParams(props) }
    if (fetchParams && typeof fetchParams.category !== 'undefined')
      delete fetchParams.category
    dispatch(searchFetch(params || fetchParams)()).then(([_, res]) =>
      generateAvailableCategories(dispatch, res.payload)
    )
  },
  selectCategory(category) {
    const searchQuery = { ...getQueryParams(props), category }

    if (searchQuery.category === 'all') delete searchQuery.category
    dispatch(setCategory(category))
    window.scrollTo(0, 0)
  },
  clearResults() {
    dispatch(clearResults())
  }
})
